import helpImage1 from "./images/help-image-1.png";
import helpImage2 from "./images/help-image-2.png";
import helpImage3 from "./images/help-image-3.png";
import helpImage4 from "./images/help-image-4.png";
import helpImage5 from "./images/help-image-5.png";
import helpImage6 from "./images/help-image-6.png";
import helpImage7 from "./images/help-image-7.png";
import helpImage8 from "./images/help-image-8.png";
import helpImage9 from "./images/help-image-9.png";
import helpImage10 from "./images/help-image-10.png";
import helpImage11 from "./images/help-image-11.png";
import helpImage12 from "./images/help-image-12.png";
import helpImage13 from "./images/help-image-13.png";

export const helpVideos = [
  {
    id: 1,
    title: "How to create an account.",
    url: "https://youtu.be/PeqS57-emTo?si=qbVZcgOpl_2B3IT1",
    image: helpImage1,
  },
  {
    id: 2,
    title: "How to update your profile.",
    description: "This video explains how to update your snappily profile.",
    url: "https://youtu.be/qZHOHJ7UG_M?si=SN0rFPJcz7_Y5oGY",
    image: helpImage2,
  },
  {
    id: 3,
    title: "How to create a property.",
    url: "https://youtu.be/s6lDPZsHdwA?si=zPDndaduX4K47GdE",
    image: helpImage3,
  },
  {
    id: 4,
    title: "How to add a room to a property.",
    url: "https://youtu.be/qFATzlGeddQ?si=2C0nnwSyYArDN72s",
    image: helpImage4,
  },
  {
    id: 5,
    title: "How to publish a room.",
    url: "https://youtu.be/3EqVdH7bc7U?si=8oq4swOL7hmXnakX",
    image: helpImage5,
  },
  {
    id: 6,
    title: "How to create a lease, and invite a tenant.",
    url: "https://youtu.be/Atn9PWGlnFo?si=RuqBL-phpO8a-IFs",
    image: helpImage6,
  },
  {
    id: 7,
    title: "How to edit a lease.",
    url: "https://youtu.be/8HLKoQ_v-k0?si=A1cD9NKMZ5fJB07z",
    image: helpImage7,
  },
  {
    id: 8,
    title: "How tenants sign their leases.",
    url: "https://youtu.be/OUkoxPdRzP0?si=TdXRurQz5BXhhBdB",
    image: helpImage8,
  },
  {
    id: 9,
    title: "How to sign a lease as a landlord.",
    url: "https://youtu.be/X4Kud9QF7NA?si=dHgKoW3vzxTq0A50",
    image: helpImage9,
  },
  {
    id: 10,
    title: "How to accept an offline payment.",
    url: "https://youtu.be/zJQdx897ql8?si=SDA14RdWWWdsD3NG",
    image: helpImage10,
  },
  {
    id: 11,
    title: "How to split a bill with your tenants.",
    url: "https://youtu.be/v2QNY0XK3Xo?si=HVAm-U-6CA_gmpUi",
    image: helpImage11,
  },
  {
    id: 12,
    title: "How to add a chore to a property.",
    url: "https://youtu.be/fRtsGMLa4Ls?si=rpRKYRMSOQpmUGPj",
    image: helpImage12,
  },
  {
    id: 13,
    title: "How to add an expense to a property.",
    url: "https://youtu.be/dYt1VfQNhFg?si=kj__il1p_Tz3y_I_",
    image: helpImage13,
  },
  {
    id: 14,
    title: "Complete tutorial on how to use Snappily.",
    url: "https://youtube.com/playlist?list=PLKaSTK-6738BLTKFop_rljSwtKPjO-V6R&si=_1tYjMTKlHRA-zp7",
    image: helpImage1,
  },
];
